define(function(require, exports, module) {
    const serverUtil = require('util/server.util');
    const user = require('user');
    const _ = require('underscore');
    const server = require('server');
    const config = require('config');
    const logger = require('util/logger.util');
    const getDynamicTagValue = require('util/swiss-theme/dynamicTag.value.util');
    const parseDtagStringToArray = require('util/swiss-theme/parseDtagStringToArray.util');

    // Url params
    const UTM_SOURCE = 'utm_source';
    const UTM_CAMPAIGN = 'utm_campaign';
    const UTM_MEDIUM = 'utm_medium';

    const addDays = (date, count) => {
        date.setDate(date.getDate() + count);

        return date;
    };

    const getTag = async (tagName) => {
        const request = {
            ID: 35547,
            responses: [35548, 35549],
            description: 'Get player tags',
            authParameters: {
                casinoName: config.get('casinoName'),
                playerName: user.get('userId')
            },
            tagName
        };

        try {
            const response = await server.send(request);
            const result = Boolean(response?.data?.tags?.length);

            logger.warn(`%cIs tracking tag already %cexist = ${result}`,
                'color: orange; font-weight: bold;',
                'color: blue;'
            );

            return result;
        } catch(error) {
            console.error(error);
            return false;
        }
    };

    const addTag = async (tagName, value) => {
        const request = {
            tags: [{
                name: tagName,
                value: value,
                type: 'text',
                expirationDate: window.Playtech.API.formatter.getDateForIms(addDays(new Date(), 30))
            }],
            ID: 35544,
            responses: [35545, 35546],
            description: 'Set player tags',
            correlationId: _.uniqueId('setPlayerTags'),
        };

        try {
            const response = await serverUtil.sendBatchRequest(
                [request], user.get('userId'));

            logger.warn(`%cNew tracking tag is %cadded`,
                'color: orange; font-weight: bold;',
                'color: blue;',
                response?.data?.tags
            );

            return response;
        } catch(error) {
            console.error(error);
        }
    };

    const removeTrackingParams = () => {
        const url = new URL(window.location.href);
        url.searchParams.delete(UTM_SOURCE);
        url.searchParams.delete(UTM_CAMPAIGN);
        url.searchParams.delete(UTM_MEDIUM);

        window.history.pushState({}, document.title, url.pathname + url.search);
    };

    const processTracking = async ({ shouldCheckTagFromServer = true }) => {
        const urlParams = new URLSearchParams(window.location.search);
        const utmSource = urlParams.get(UTM_SOURCE);
        const utmCampaign = urlParams.get(UTM_CAMPAIGN);
        const utmMedium = urlParams.get(UTM_MEDIUM);
        const utmMediumValuesDTag = getDynamicTagValue('UTM_MEDIUM_VALUES');
        const parsedUtmMediumValues = parseDtagStringToArray(utmMediumValuesDTag);

        if (
            utmSource === 'lead' &&
            utmCampaign === 'Leadgeneration_FDP' &&
            parsedUtmMediumValues.includes(utmMedium)
        ) {
            const tagName = 'sc/tracking/casino';
            const exist = !shouldCheckTagFromServer ? false : await getTag(tagName);

            if (!exist) {
                await addTag(tagName, utmMedium);
            }

            removeTrackingParams();
        }
    };

    module.exports = processTracking;
});